import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const testimonials = [{
  quote: 'Sinceramente dudé antes de pagar. Nunca había comprado algo así online. Pero la garantía me dio confianza. Lo compré un martes a la noche y el jueves ya tenía los PDFs y había empezado el Tomo 1. Vale cada peso.',
  name: 'Florencia M.',
  age: 38,
  city: 'Rosario'
}, {
  quote: 'Lo que más me frenaba era no saber si me iban a mandar los archivos de verdad. Me los mandaron en 5 minutos por email. Perfecto. El Tomo 3 sobre el desapego fue lo que me faltaba después de años estudiando manifestación.',
  name: 'Diego A.',
  age: 42,
  city: 'Córdoba'
}, {
  quote: 'Dudé por el precio pero lo dividí: son 8 documentos por $19.990. Menos de $2.500 por documento. Por ese precio no encontrás ni un libro físico en una librería. Y esto vale mucho más que cualquier libro.',
  name: 'Mariana L.',
  age: 31,
  city: 'CABA'
}, {
  quote: 'El Plan de 21 Días fue la clave para mí. Siempre empezaba y dejaba. Con el plan sabía exactamente qué hacer cada día. Llegué al día 21 por primera vez en mi vida.',
  name: 'Ana P. G.',
  age: 45,
  city: 'Lima'
}];
export function TestimonialsSection() {
  return <SectionWrapper bgColor="bg-brand-testimonial" data-id="element-238">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold mb-10" data-id="element-239">
        Lo que dicen quienes ya compraron:
      </h2>

      <div className="space-y-6" data-id="element-240">
        {testimonials.map((t, i) => <div key={i} className="border-l-2 border-brand-gold/40 pl-6 md:pl-8 py-2" data-id="element-241">
            <p className="text-brand-ivory/85 font-body text-base md:text-lg italic leading-relaxed" data-id="element-242">
              "{t.quote}"
            </p>
            <p className="text-brand-gold font-body font-semibold text-sm mt-4" data-id="element-243">
              — {t.name}, {t.age} años · {t.city}
            </p>
          </div>)}
      </div>
    </SectionWrapper>;
}